import React from "react";

const MODE_DEFAULTS = {
  light: {
    textColor: "#2B3053",
    pillColor: "#2B3053",
    pillTextColor: "#F5A623",
    accentColor: "#F5A623",
  },
  dark: {
    textColor: "#F8FAFC",
    pillColor: "#F5A623",
    pillTextColor: "#FFFFFF",
    accentColor: "#F5A623",
  },
};

function resolveLogoColors({
  mode = "light",
  textColor,
  pillColor,
  pillTextColor,
  accentColor,
}) {
  const base = MODE_DEFAULTS[mode] || MODE_DEFAULTS.light;
  return {
    textColor: textColor ?? base.textColor,
    pillColor: pillColor ?? base.pillColor,
    pillTextColor: pillTextColor ?? base.pillTextColor,
    accentColor: accentColor ?? base.accentColor,
  };
}

/** Inline mark from `public/HppyRxLogo.svg` — colors are configurable. */
function HppyRxLogoMark({
  className = "",
  textColor,
  pillColor,
  pillTextColor,
  accentColor,
  ...rest
}) {
  return (
    <svg
      viewBox="0 0 949 653"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Hppy Rx"
      {...rest}
    >
      <path
        d="M23.7842 349V86.2H89.3042V235.96H80.6642C80.6642 215.8 83.1842 198.88 88.2242 185.2C93.2642 171.52 100.584 161.2 110.184 154.24C120.024 147.28 132.144 143.8 146.544 143.8H149.424C171.024 143.8 187.464 151.6 198.744 167.2C210.264 182.8 216.024 205.72 216.024 235.96V349H150.504V233.44C150.504 224.32 147.744 216.88 142.224 211.12C136.704 205.12 129.384 202.12 120.264 202.12C111.144 202.12 103.704 205.12 97.9442 211.12C92.1842 216.88 89.3042 224.56 89.3042 234.16V349H23.7842ZM238.434 421V150.28H290.274V235.96H284.514C285.234 216.52 289.074 199.96 296.034 186.28C303.234 172.6 312.954 162.28 325.194 155.32C337.434 148.12 351.474 144.52 367.314 144.52C380.994 144.52 393.354 147.04 404.394 152.08C415.434 156.88 424.914 163.84 432.834 172.96C440.754 181.84 446.754 192.4 450.834 204.64C455.154 216.88 457.314 230.32 457.314 244.96V253.6C457.314 268.24 455.394 281.8 451.554 294.28C447.714 306.52 441.954 317.32 434.274 326.68C426.594 335.8 417.114 342.88 405.834 347.92C394.794 352.96 382.074 355.48 367.674 355.48C352.314 355.48 338.754 352.48 326.994 346.48C315.234 340.24 305.874 331 298.914 318.76C292.194 306.28 288.594 290.68 288.114 271.96L303.954 291.4V421H238.434ZM347.874 301.48C356.514 301.48 364.074 299.32 370.554 295C377.274 290.44 382.434 284.2 386.034 276.28C389.874 268.36 391.794 259.36 391.794 249.28C391.794 238.96 389.874 230.08 386.034 222.64C382.434 214.96 377.394 209.08 370.914 205C364.434 200.68 356.754 198.52 347.874 198.52C339.954 198.52 332.514 200.32 325.554 203.92C318.834 207.52 313.314 212.8 308.994 219.76C304.674 226.72 302.514 235.12 302.514 244.96V257.2C302.514 266.56 304.794 274.6 309.354 281.32C313.914 287.8 319.674 292.84 326.634 296.44C333.594 299.8 340.674 301.48 347.874 301.48ZM471.717 421V150.28H523.557V235.96H517.797C518.517 216.52 522.357 199.96 529.317 186.28C536.517 172.6 546.237 162.28 558.477 155.32C570.717 148.12 584.757 144.52 600.597 144.52C614.277 144.52 626.637 147.04 637.677 152.08C648.717 156.88 658.197 163.84 666.117 172.96C674.037 181.84 680.037 192.4 684.117 204.64C688.437 216.88 690.597 230.32 690.597 244.96V253.6C690.597 268.24 688.677 281.8 684.837 294.28C680.997 306.52 675.237 317.32 667.557 326.68C659.877 335.8 650.397 342.88 639.117 347.92C628.077 352.96 615.357 355.48 600.957 355.48C585.597 355.48 572.037 352.48 560.277 346.48C548.517 340.24 539.157 331 532.197 318.76C525.477 306.28 521.877 290.68 521.397 271.96L537.237 291.4V421H471.717ZM581.157 301.48C589.797 301.48 597.357 299.32 603.837 295C610.557 290.44 615.717 284.2 619.317 276.28C623.157 268.36 625.077 259.36 625.077 249.28C625.077 238.96 623.157 230.08 619.317 222.64C615.717 214.96 610.677 209.08 604.197 205C597.717 200.68 590.037 198.52 581.157 198.52C573.237 198.52 565.797 200.32 558.837 203.92C552.117 207.52 546.597 212.8 542.277 219.76C537.957 226.72 535.797 235.12 535.797 244.96V257.2C535.797 266.56 538.077 274.6 542.637 281.32C547.197 287.8 552.957 292.84 559.917 296.44C566.877 299.8 573.957 301.48 581.157 301.48ZM701.518 428.2V373.48H747.238C752.758 373.48 757.438 372.76 761.278 371.32C765.118 369.88 768.238 367.48 770.638 364.12C773.038 361 774.838 356.56 776.038 350.8L820.678 150.28H882.598L830.398 363.4C826.558 379.72 821.158 392.56 814.198 401.92C807.478 411.52 798.118 418.24 786.118 422.08C774.358 426.16 758.998 428.2 740.038 428.2H701.518ZM764.518 344.68V294.28H806.278V344.68H764.518ZM734.278 344.68L676.318 150.28H741.838L796.198 344.68H734.278Z"
        fill={textColor}
      />
      <path
        d="M863.884 349V277.72H934.444V349H863.884Z"
        fill={accentColor}
      />
      <path
        d="M626 454H903C928.405 454 949 474.595 949 500V607C949 632.405 928.405 653 903 653H672C646.595 653 626 632.405 626 607V454Z"
        fill={pillColor}
      />
      <path
        d="M717.302 606V520.504H739.605V557.676H739.295C739.295 545.699 741.773 536.302 746.73 529.487C751.789 522.673 759.017 519.265 768.413 519.265H771.821V543.427H765.316C759.017 543.427 754.112 545.131 750.602 548.538C747.194 551.946 745.49 556.85 745.49 563.252V606H717.302ZM774.711 606L799.958 559.845L799.338 563.872L775.486 520.504H805.843L819.628 548.538H822.106L835.116 520.504H863.615L840.847 564.646L841.466 561.239L868.261 606H837.904L821.177 576.107H818.698L803.21 606H774.711Z"
        fill={pillTextColor}
      />
    </svg>
  );
}

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {boolean} [props.compact] - Square "Rx" fallback when space is tight
 * @param {"light"|"dark"} [props.mode] - Default palette when colors omitted
 * @param {string} [props.textColor] - Main wordmark
 * @param {string} [props.pillColor] - Pill background
 * @param {string} [props.pillTextColor] - "Rx" inside the pill
 * @param {string} [props.accentColor] - Small badge next to the wordmark (defaults to pillTextColor)
 */
export default function Logo({
  className = "",
  compact = false,
  mode = "light",
  textColor,
  pillColor,
  pillTextColor,
  accentColor,
}) {
  const colors = resolveLogoColors({
    mode,
    textColor,
    pillColor,
    pillTextColor,
    accentColor,
  });

  if (compact) {
    return (
      <div
        className={`inline-flex h-10 w-10 items-center justify-center rounded-lg text-sm font-semibold ${className}`}
        style={{
          backgroundColor: colors.pillColor,
          color: colors.pillTextColor,
        }}
        aria-label="Hppy Rx"
      >
        Rx
      </div>
    );
  }

  return (
    <HppyRxLogoMark
      className={className}
      textColor={colors.textColor}
      pillColor={colors.pillColor}
      pillTextColor={colors.pillTextColor}
      accentColor={colors.accentColor}
    />
  );
}

export { HppyRxLogoMark, resolveLogoColors };
